import { autoinject } from 'aurelia-framework';
import { PenTabProps } from '../tabs';

@autoinject
export class Tab {
  data: PenTabProps;

  activate(data: PenTabProps) {
    this.data = data;
  }
}
